import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "size--a" }
const _hoisted_2 = { class: "size--b" }
const _hoisted_3 = { class: "size--b" }
const _hoisted_4 = { class: "size--c line--last" }

import InnInput from "@/components/ds/input/Input.vue";
import { PropType } from "vue";
import { Line } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineCount',
  props: {
    line: {
        type: Object as PropType<Line>,
        required: true,
    },
    locked: {
        type: Boolean,
        required: true,
    },
    currency: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.locked)
        ? (_openBlock(), _createBlock(InnInput, {
            key: 0,
            placeholder: "Post",
            modelValue: __props.line.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.line.text) = $event)),
            compact: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (__props.locked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.line.text), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (!__props.locked)
        ? (_openBlock(), _createBlock(InnInput, {
            key: 0,
            modelValue: __props.line.hours,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.line.hours) = $event)),
            placeholder: "uren",
            compact: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (__props.locked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.line.hours), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", null, "×", -1)),
    _createElementVNode("div", _hoisted_3, [
      (!__props.locked)
        ? (_openBlock(), _createBlock(InnInput, {
            key: 0,
            modelValue: __props.line.rate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.line.rate) = $event)),
            placeholder: "Tarief",
            compact: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (__props.locked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.line.rate), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.line.hours * __props.line.rate) + " " + _toDisplayString(__props.currency), 1)
  ], 64))
}
}

})